import { api, getCurrentUser } from '@creditsights/api-ui-web';
import { Preference, DocketAlertsDto, AlertType, UpdateDocketAlertPreferencesArgs } from '../../models/DocketAlerts';
import { PROFILES_MODULE_V1_URI } from '../services.constants';

const DocketAlertsUri = (userId: string, caseId: number, companyId: number) =>
  `${PROFILES_MODULE_V1_URI}${userId}/docket-alerts/${caseId}/${companyId}`;

export const fetchDocketAlertPreferences = async (caseId: number, companyId: number): Promise<Preference> => {
  const { userId } = getCurrentUser();
  if (!userId) {
    return { mode: AlertType.None };
  }
  const { data } = await api.get<DocketAlertsDto>(DocketAlertsUri(userId, caseId, companyId));
  const mode = data?.mode ?? AlertType.None;
  return { mode };
};

export const updateDocketAlertPreferences = async (args: UpdateDocketAlertPreferencesArgs): Promise<Preference> => {
  const { userId } = getCurrentUser();
  const updateDto: DocketAlertsDto = {
    mode: args.preferences.mode,
    caseId: args.caseId,
    companyId: args.companyId,
  };
  if (!userId) {
    throw new Error('No user found.');
  }
  if (!args.caseId) {
    throw new Error('Case id is invalid.');
  }
  if (!args.companyId) {
    throw new Error('Company id is invalid.');
  }
  const { data } = await api.patch<DocketAlertsDto>(DocketAlertsUri(userId, args.caseId, args.companyId), updateDto);
  return data;
};
